import { YesNoMaybe } from "types/YesNoMaybe";
import { FoodPreference } from "../api/RsvpApi";
import {
    Egg as VegetarianIcon,
    KebabDining as MeatIcon,
    SoupKitchen as VeganIcon,
    Hotel as HotelIcon,
    Home as HomeIcon,
    BreakfastDining as BreakfastIcon,
    LocalDining as NoBreakfastIcon,
    QuestionMark as MaybeIcon,
    SvgIconComponent,
} from '@mui/icons-material';

export const FOOD_ICONS = {
    Meat: MeatIcon,
    Vegan: VeganIcon,
    Vegetarian: VegetarianIcon,
} as Record<FoodPreference, SvgIconComponent>;

export const HOTEL_ICONS = {
    yes: HotelIcon,
    no: HomeIcon,
    maybe: MaybeIcon,
} as Record<YesNoMaybe, typeof HotelIcon>;

export const BREAKFAST_ICONS = {
    yes: BreakfastIcon,
    no: NoBreakfastIcon,
    maybe: MaybeIcon,
} as Record<YesNoMaybe, typeof BreakfastIcon>;